module.exports = __webpack_public_path__ + "static/media/student2.b6fd8a4e.svg";